import styles from '../../assets/styles/Onboarding/Onboarding.module.scss';
import OnboardSuccessImg from '../../assets/img/MimaCongrats.png';
import { MimaButton } from '../../components';
import OnboardLeft from './OnboardLeft';
import React, { useState } from 'react';

const AlmostThere3 = () => {
	const [invalidCred, setInvalidCred] = useState('');
	const [loading, setLoading] = useState(false);
	return (
		<div className={styles.container}>
			<OnboardLeft
				crumbs1={styles.crumbs__default}
				crumbs2={styles.crumbs__default}
				crumbs3={styles.crumbs__active}
			/>
			<div className={styles.right}>
				<img
					src={OnboardSuccessImg}
					className={styles.os__img}
					alt="Password Change Success"
				/>
				<h4
					className={`${styles.text__center} ${styles.text__color__primary} ${styles.text__subtitle} ${styles.mb_10}`}>
					Congratulations, Funmi
					<br />
					Your account is all set up!
				</h4>

				<MimaButton title="Continue" width={38} loading={loading} />
			</div>
		</div>
	);
};

export default AlmostThere3;
